import React, { useEffect, useState } from 'react'
import { getFirestore, addDoc, collection, getDocs } from "firebase/firestore";
import { app } from '../../Firebase/Firebaseapp';
import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux';
import { getStorage, uploadBytes, ref } from "firebase/storage";
import CategoryCard from '../components/CategoryCard';


const fireStoreDb = getFirestore(app);
const fireStorage = getStorage(app);

const AddCategories = () => {

  const { user } = useSelector((state) => state.FirebaseAuth)
  const [input, setInput] = useState("")
  const [Categories,setCategories] = useState("")
  const [reRender,setRender]=useState(false)
  const [BrandLogo, setLogo] = useState("")

  const CategoriessData = () => {
      return getDocs(collection(fireStoreDb, 'Categories'));
  }


  const SubmitData = () => {
      RegisterNewAdmin(input)
      console.log(input)
      setRender(!reRender)
  }

  const RegisterNewAdmin = async (input) => {
    const imageRef = ref(fireStorage, `uploads/CategoryLogo/${uuidv4()}-${BrandLogo.name}`)
    const uploadImg = await uploadBytes(imageRef, BrandLogo);

      await addDoc(collection(fireStoreDb, 'Categories'), {
          id: uuidv4(),
          Categories: input,
          SuperAdmin: user,
          CategoryLogo: uploadImg.ref.fullPath
      })
  }

  useEffect(() => {
      CategoriessData().then((Categoriess) =>setCategories(Categoriess.docs));

      console.log("I am Addcategoris")
  
  }, [reRender])

  return (
    <div className='w-[100%] flex justify-center items-center sm:flex-row flex-col min-h-screen'>
            <div className="  py-6 flex flex-col justify-center sm:py-12  sm:w-[50%] w-[90%]">
                <div className="relative py-3 sm:max-w-xl sm:mx-auto">
                    <div
                        className="absolute inset-0 bg-gradient-to-r from-blue-400 to-[crimson] shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl">
                    </div>
                    <div className="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">
                        <div className="max-w-md mx-auto">
                            <div>
                                <h1 className="text-2xl font-semibold">Add New Categories </h1>
                            </div>
                            <div className="divide-y divide-gray-200">
                                <div className="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                                <div className="relative pt-5">
                                        <input autoComplete="off" id="email"  type="file"  name='img' onChange={(e) => { setLogo(e.target.files[0]) }}  className="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600" placeholder="Email address" required />
                                        <label htmlFor="email" className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm">Add Logo </label>
                                    </div>
                                    <div className="relative">
                                        <input autoComplete="off" id="email" name="email" type="text" value={input} onChange={(e) => setInput(e.target.value)} className="peer placeholder-transparent h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600" placeholder="Email address" />
                                        <label htmlFor="email" className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm">Add New Categories </label>
                                    </div>

                                    <div className="relative mx-7">
                                        <button className="bg-[crimson] text-white rounded-full px-5 py-1" type='submit' onClick={SubmitData}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="antialiased  text-gray-600  px-4 sm:w-[50%]  w-[100%]" >
            <div class="w-full  px-4 mx-auto mt-24">
    <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white ">
      <div class="rounded-t mb-0 px-4 py-3 border-0">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full px-4 max-w-full flex-grow flex-1">
            <h3 class="font-semibold text-base text-blueGray-700">
              All Categoriess
            </h3>
          </div>
          <div class="relative w-full px-4 max-w-full flex-grow flex-1 text-right">
            <button class="bg-indigo-500 text-white active:bg-indigo-600 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
              See all
            </button>
          </div>
        </div>
      </div>
      
      <div class="block w-full overflow-x-auto">
        <table class="items-center w-full border-collapse text-blueGray-700  ">
          <thead class="thead-light ">
            <tr>
              <th class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
               No 
              </th>
              <th class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
               Logo
              </th>
             
              <th class="px-6 bg-blueGray-50 text-blueGray-700 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left min-w-140-px">
                Categories Name
              </th>
            </tr>
          </thead>
          <tbody>

          {
            Categories && Categories.map((x, index) => {
                                            return (

                                               <CategoryCard x={x.data()} index={index} categoryId={x.id} reRender={reRender} key={index}/>

                                            )
                                        })
                                    }

          </tbody>
        </table>
      </div>
    </div>
  </div>
            </div>

        </div>
  )
}

export default AddCategories